<div class="ad-skin">
  <div class="d-none d-xl-block">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="adSkin"
    ></flo-lazy>
  </div>
</div>
<main class="rankings-page" *ngIf="ranking$ | async as rankings">
  <div class="mb-3 d-none d-lg-block">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="adLeaderboardLarge"
      [detectorHeight]="90"
    >
    </flo-lazy>
  </div>
  <div class="my-3 d-none d-md-block d-lg-none">
    <flo-lazy
      [componentConstructor]="AdComponent"
      [initialProps]="adLeaderboardSmall"
      [detectorHeight]="90"
    >
    </flo-lazy>
  </div>
  <div class="container min-vh-100 right-rail" data-test="container">
    <div class="py-3 px-3 px-lg-4 w-100">
      <h1 class="h3 mb-0">Rankings</h1>
    </div>
    <div class="row main-row" data-test="ranking-list-container">
      <section class="col-md-12 col-lg-8 wrapper">
        <ul>
          <li
            class="rankings-item"
            data-test="ranking-list-item"
            *ngFor="let ranking of rankings.data; trackBy: trackByRanking"
          >
            <a
              [floCustomLink]="ranking?.latest_ranking_slug_uri"
              class="primary-color-text-hover"
            >
              <flo-list-image
                [imageUrl]="ranking?.asset?.url"
                [title]="ranking?.title"
              >
                <span
                  class="flo-footnote"
                  data-test="date"
                  *ngIf="ranking?.latest_publish_date"
                  >Last Updated On
                  {{ ranking?.latest_publish_date | date: 'mediumDate' }}</span
                >
              </flo-list-image>
            </a>
          </li>
        </ul>
        <div class="load-more" data-test="load-more">
          <button
            floAnalytics
            name="See More"
            type="button"
            class="btn btn-primary"
            (click)="setResultsLimitNumber(rankings.meta)"
            *ngIf="rankings?.showButton"
          >
            See More
          </button>
        </div>
      </section>
      <aside class="col-md-12 col-lg-4 rail d-none d-lg-flex">
        <div class="d-flex justify-content-center mt-2 py-3 stick-to-header">
          <flo-lazy
            [componentConstructor]="AdComponent"
            [initialProps]="adSidebarRectangle"
            [detectorHeight]="250"
          ></flo-lazy>
        </div>
      </aside>
    </div>
  </div>
</main>
<div class="stick-to-footer">
  <flo-lazy
    class="adhesion-ad d-block d-sm-none"
    [componentConstructor]="AdComponent"
    [detectorHeight]="50"
    [initialProps]="adAdhesion"
  ></flo-lazy>
</div>
